// extracted by mini-css-extract-plugin
export var compactFilters = "_hf-4";
export var detailImage = "_hf-1";
export var dropdownContainer = "_hf-2";
export var imageContainer = "_hf-0";
export var selectedCard = "_hf-3";